import classNames from 'classnames';
import React, { useState } from 'react';

import VideoPlayerButtonHoverTag from '../../button-hover-tag';

import './styles.less';

export default function ControlBarButton(props) {
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);

  const inHoverState = hovered && !props.seeking;
  const inFocusState = focused && !props.seeking;

  function clicked(e) {
    props.onClick(e);

    // e.detail === 1 means a click
    // e.detail === 0 means a focused button + enter
    // blur on click to not show the blue outline
    // do not blur on enter to keep the blue outline there
    // and the button focused
    e.detail && document.activeElement.blur();
    setHovered(false);
  }

  return (
    <button
      className={classNames('control-bar-button', props.className, {
        hovered: inHoverState,
      })}
      onClick={clicked}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    >
      {props.children}
      <VideoPlayerButtonHoverTag
        text={props.hoverTagText}
        hovered={inHoverState || inFocusState}
        position="top"
      />
    </button>
  );
}
